/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityRegion } from './FacilityRegion';
import {
    FacilityRegionFromJSON,
    FacilityRegionFromJSONTyped,
    FacilityRegionToJSON,
} from './FacilityRegion';

/**
 * 
 * @export
 * @interface FindAllFacilityRegions200Response
 */
export interface FindAllFacilityRegions200Response {
    /**
     * 
     * @type {Array<FacilityRegion>}
     * @memberof FindAllFacilityRegions200Response
     */
    data?: Array<FacilityRegion>;
}

/**
 * Check if a given object implements the FindAllFacilityRegions200Response interface.
 */
export function instanceOfFindAllFacilityRegions200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllFacilityRegions200ResponseFromJSON(json: any): FindAllFacilityRegions200Response {
    return FindAllFacilityRegions200ResponseFromJSONTyped(json, false);
}

export function FindAllFacilityRegions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFacilityRegions200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FacilityRegionFromJSON)),
    };
}

export function FindAllFacilityRegions200ResponseToJSON(value?: FindAllFacilityRegions200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FacilityRegionToJSON)),
    };
}

